var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapshot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3467_37193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33832 10.5067C2.48591 10.5067 1.63351 10.5033 0.779999 10.5078C0.472867 10.509 0.164623 10.5044 0.034426 10.1567C-0.0913199 9.82255 0.149044 9.63452 0.361588 9.44875C3.84575 6.39834 7.32991 3.34794 10.813 0.298666C11.0578 0.0845823 11.3115 -0.152155 11.6387 0.127626C11.9569 0.40061 11.7889 0.705311 11.642 0.996419C10.6405 2.97074 9.63896 4.94507 8.63856 6.92053C8.44642 7.29961 8.56734 7.48991 9.00133 7.49142C10.6505 7.49142 12.3008 7.49255 13.9499 7.49142C14.2693 7.49142 14.6132 7.4631 14.7511 7.84143C14.8936 8.23448 14.5731 8.41798 14.3405 8.62187C10.9009 11.6372 7.459 14.6502 4.01601 17.6621C3.7634 17.883 3.50412 18.1729 3.15025 17.8705C2.80751 17.5771 3.01894 17.2566 3.1714 16.9541C4.1629 14.9957 5.15551 13.0372 6.14701 11.0787C6.33915 10.6989 6.2186 10.5086 5.78535 10.5078C4.96967 10.5078 4.154 10.5078 3.33832 10.5078V10.5067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3467_37193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7857,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot);
export default __webpack_public_path__ + "static/media/snapshot.f502fe00.svg";
export { ForwardRef as ReactComponent };